import React, { useEffect, useState } from "react";
import styles from "./CertificateUpload.module.scss";
import { ReactComponent as PdfIcon } from "../../../icons/pdf-icon-green.svg";
import { ReactComponent as DeleteIcon } from "../../../icons/delete-icon-gray.svg";
import { useDropzone } from "react-dropzone";
import util from "../../../_helpers/util";
import { confirmAlert } from "react-confirm-alert";
import { ReactComponent as CloseIcon } from "../../../icons/close-icon.svg";

const UploadedCertificate = ({ certificate, onDeleteUploadedFile }) => {
  return (
    <div className="certificate">
      <div className="icon-and-name">
        <PdfIcon />
        <div className="name-and-size">
          <p>{certificate?.file?.name || certificate.file_name}</p>
          {certificate?.file && (
            <p>{util.fileSize(certificate?.file?.size, true)}</p>
          )}
        </div>
      </div>
      <div
        className="delete-icon"
        onClick={() => onDeleteUploadedFile(certificate)}
      >
        <DeleteIcon className="icon" />
      </div>
    </div>
  );
};

const CertificateUpload = (props) => {
  const {
    onUpload,
    certificate,
    onDeleteUploadedFile,
    uploadAreaId,
    onCloseUploaderArea,
    certificateTypeOptions,
  } = props;
  const [certType, setCertType] = useState("");

  const MAX_FILE_SIZE = 2*1024*1024;

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    multiple: false,
    disabled: !certType || certificate?.type || certificate?.certificate_id,
    accept: [".pdf"],
  });

  const onFileUpload = () => {
    onUpload(acceptedFiles, certType, certificate?.tempId ?? "");
    setCertType("");
  };

  useEffect(() => {
    if (acceptedFiles.length) {
      if (acceptedFiles[0].type !== "application/pdf") {
        return confirmAlert({
          title: "ERROR!",
          message: "The selected file type is invalid!",
          buttons: [
            {
              label: "Close",
              onClick: () => {},
            },
          ],
        });
      } else if (acceptedFiles[0].size > MAX_FILE_SIZE) {
        return confirmAlert({
          title: "ERROR!",
          message: "The file size exceeds the maximum limit of 2MB! Please upload a smaller file.",
          buttons: [
            {
              label: "Close",
              onClick: () => {},
            },
          ],
        });
      }
      onFileUpload();
    }
  }, [acceptedFiles]);

  useEffect(() => {
    setCertType(certificate?.type || certificate?.certificate_id);
  }, [certificate]);

  return (
    <div>
      <div className={styles.CertificateUpload}>
        <div className="upload-wrapper">
          <select
            className={`certificate-upload-select ${
              (certificate?.type || certificate?.certificate_id) && "cert-disabled"
            }`}
            onChange={(e) => setCertType(e.target.value)}
            value={certType}
            disabled={certificate?.type || certificate?.certificate_id}
          >
            <option value="">Select certificate / document type</option>
            {certificateTypeOptions.map((option) => (
              <option value={option.id}>{option.name}</option>
            ))}
          </select>
          <div
            {...getRootProps({
              className: `dropzone ${
                (certificate?.type || certificate?.certificate_id) && "cert-disabled"
              }`,
            })}
          >
            <input {...getInputProps()} />
            <p>Choose Files</p>
          </div>
          {!certificate && uploadAreaId && (
            <div
              className="close-icon"
              onClick={() => onCloseUploaderArea(uploadAreaId)}
            >
              <CloseIcon />
            </div>
          )}
        </div>
        <div className={`${certificate && "certificates-list"}`}>
          {certificate && (
            <UploadedCertificate
              certificate={certificate}
              onDeleteUploadedFile={onDeleteUploadedFile}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CertificateUpload;
